import { sessionStorage } from '../../../utils/storageUtils';

export interface ChurchAccountRedirect {
  action: 'link' | 'create';
  redirectPath: string;
}

const STORAGE_KEY = 'churchAccountRedirect';

export const setChurchAccountRedirect = (redirect: ChurchAccountRedirect) => {
  sessionStorage.setItem(STORAGE_KEY, redirect);
};

export const getChurchAccountRedirect = (): ChurchAccountRedirect | null => {
  return sessionStorage.getItem(STORAGE_KEY);
};

export const clearChurchAccountRedirect = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};
